import _construct from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _get from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BaseObject, assign, copy, get, init, isArray, isIterable, isObject, isString, nest, raw, set } from './__util__';

var Topojson = /*#__PURE__*/function (_BaseObject) {
  _inherits(Topojson, _BaseObject);

  var _super = _createSuper(Topojson);

  function Topojson() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _classCallCheck(this, Topojson);

    _this = _super.call(this);
    init(_assertThisInitialized(_this));
    set(_assertThisInitialized(_this), "type", "topojson");
    args = args.map(function (_) {
      return isObject(_) ? {
        values: _
      } : isArray(_) ? {
        values: raw(_)
      } : isIterable(_) ? {
        values: raw(_)
      } : isString(_) ? {
        url: _
      } : _;
    });
    assign.apply(void 0, [_assertThisInitialized(_this)].concat(_toConsumableArray(args)));
    return _this;
  }

  _createClass(Topojson, [{
    key: "feature",
    value: function feature(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "feature", value);
        return obj;
      } else {
        return get(this, "feature");
      }
    }
  }, {
    key: "mesh",
    value: function mesh(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "mesh", value);
        return obj;
      } else {
        return get(this, "mesh");
      }
    }
  }, {
    key: "parse",
    value: function parse(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "parse", value);
        return obj;
      } else {
        return get(this, "parse");
      }
    }
  }, {
    key: "type",
    value: function type(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "type", value);
        return obj;
      } else {
        return get(this, "type");
      }
    }
  }, {
    key: "url",
    value: function url(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "url", value);
        return obj;
      } else {
        return get(this, "url");
      }
    }
  }, {
    key: "values",
    value: function values(value) {
      if (arguments.length) {
        var obj = copy(this);
        value = isArray(value) ? raw(value) : isObject(value) ? raw(value) : value;
        set(obj, "values", value);
        return obj;
      } else {
        return get(this, "values");
      }
    }
  }, {
    key: "name",
    value: function name(value) {
      if (arguments.length) {
        var obj = copy(this);
        set(obj, "name", value);
        return obj;
      } else {
        return get(this, "name");
      }
    }
  }, {
    key: "toObject",
    value: function toObject() {
      return nest(_get(_getPrototypeOf(Topojson.prototype), "toObject", this).call(this), ["url", "values", "name"], "format");
    }
  }]);

  return Topojson;
}(BaseObject);

export function topojson() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return _construct(Topojson, args);
}